<template>
  <div style="padding: 0 32px 0 48px;">
    <Descriptions :gutter="24">
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.productFuncType')"
      >
        {{ $t('Product.service') }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.productFuncName')"
      >
        {{ info.name | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.identifier')"
      >
        {{ info.identifier | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.command')"
      >
        {{ info.cmd | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.eventType')"
      >
        {{ info.type | formatType }}
      </DescriptionsItem>
      <DescriptionsItem :span="24" :labelWidth="labelWidth" :labelAlign="labelAlign" label="Hex">
        {{ info.hex | formatHex }}
      </DescriptionsItem>
      <JsonParamsDetailItem
        :label="$t('Product.outPutParam')"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :jsonArr="info.outputData"
      ></JsonParamsDetailItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Common.desc')"
      >
        {{ info.desc | format }}
      </DescriptionsItem>
    </Descriptions>
  </div>
</template>

<script>
import Descriptions from '@/components/Descriptions'
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import JsonParamsDetailItem from './JsonParamsDetailItem'
import i18n from '@/locales/index'
import { format } from '@/utils/utils'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    },
    tslVersionId: {
      type: String
    }
  },
  components: {
    Descriptions,
    DescriptionsItem,
    JsonParamsDetailItem
  },
  data() {
    return {
      info: { specs: {} },
      labelWidth: '100px',
      labelAlign: 'right'
    }
  },
  created() {
    if (this.tslVersionId) {
      this.getDetail()
    }
  },
  filters: {
    format,
    formatType(val) {
      switch (val) {
        case 'info':
          return `${i18n.t('Common.info')}`
        case 'alert':
          return `${i18n.t('Common.alert')}`
        case 'error':
          return `${i18n.t('Common.error')}`
        default:
          return '-'
      }
    },
    formatHex(val) {
      if (val === true) {
        return this.$t('Common.yes')
      } else if (val === false) {
        return this.$t('Common.no')
      } else {
        return '-'
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    getDetail() {
      const params = {
        tslVersionId: this.tslVersionId,
        identifier: this.row.identifier
      }
      this.$ajax
        .get(this.$api.product.product_tsl_event_detail, params)
        .then((res) => {
          this.info = res.data
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
